import axios from '../utils/axios';

export default function fetchLeads(adminId, params) {
    
    return (
        axios.get('/admin/' + adminId + '/getLeads', { params })
    )
}
